(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('funzione', {
            parent: 'entity',
            url: '/funzione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.funzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/funzione/funziones.html',
                    controller: 'FunzioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('funzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('funzione-detail', {
            parent: 'entity',
            url: '/funzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.funzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/funzione/funzione-detail.html',
                    controller: 'FunzioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('funzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Funzione', function($stateParams, Funzione) {
                    return Funzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'funzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('funzione-detail.edit', {
            parent: 'funzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('funzione.new', {
            parent: 'funzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('funzione');
                });
            }]
        })
        .state('funzione.edit', {
            parent: 'funzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('funzione.delete', {
            parent: 'funzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-delete-dialog.html',
                    controller: 'FunzioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
